export default __webpack_public_path__ + "static/media/review-contest-en.7136921a.png";